import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PageHeader, Skeleton } from 'antd';
import history from '@utils/history';
import { CouponForm } from '@containers/coupons';
import { CouponsSelectors } from '@redux/CouponsRedux';

function EditCouponPage(props) {
  const { loadig, couponData } = props;

  if (loadig) {
    return (
      <div className="coupons main-page">
        <PageHeader
          style={{
            border: '1px solid rgb(235, 237, 240)'
          }}
          onBack={() => history.goBack()}
        />

        <div className="coupon main-content">
          <Skeleton />
        </div>
      </div>
    );
  }

  const { couponID: couponId, title } = couponData;

  return (
    <div className="coupons main-page">
      <PageHeader
        title={`Edit: ${title}`}
        style={{
          border: '1px solid rgb(235, 237, 240)'
        }}
        onBack={() => history.goBack()}
      />
      <div className="main-content">
        <CouponForm couponId={couponId} couponData={couponData} />
      </div>
    </div>
  );
}

EditCouponPage.propTypes = {
  match: PropTypes.object,
  loadCoupon: PropTypes.func,
  loadig: PropTypes.bool,
  couponData: PropTypes.object
};

const mapStateToProps = state => ({
  loadig: CouponsSelectors.selectLoading(state),
  couponData: CouponsSelectors.selectCouponData(state)
});

export default connect(mapStateToProps)(EditCouponPage);
